import React from "react";
import { Button } from "react-bootstrap";
import { OrderUnit } from "./data-display/OrderUnit";
import { PriceSummary } from "./data-display/PriceSummary";

const DigitalizedOrderDetail = ({
  merchantStoreName,
  orderDate,
  orderMethod,
  contactPerson,
  furtherInformation,
  orderItems,
  discountsInKind,
  grossPrice,
  buttonOnClick,
  buttonText,
}) => {
  return (
    <div className="digitalized-orders-detail">
      <h4>Gemeldetete Aufträge</h4>
      <h1>{merchantStoreName}</h1>
      <div className="divider" />
      <div>
        <p>
          <strong>Bestelldatum</strong>
          <br />
          {orderDate}
        </p>

        <p>
          <strong>Bestellart</strong>
          <br />
          {orderMethod}
        </p>

        <p>
          <strong>Ansprechpartner</strong>
          <br />
          {contactPerson}
        </p>

        <p>
          <strong>Weitere Notizen</strong>
          <br />
          {furtherInformation}
        </p>

        <h4>Bestelleinheiten</h4>

        {orderItems?.map((oi, index) => (
          <OrderUnit
            orderUnit={oi?.orderUnit}
            count={oi?.amount}
            isFree={false}
            key={index}
          />
        ))}

        <h4>Naturalrabatt</h4>

        {discountsInKind ? (
          discountsInKind?.map((dc, index) => (
            <OrderUnit
              orderUnit={dc?.orderUnit}
              count={dc?.count}
              isFree
              key={index}
            />
          ))
        ) : (
          <p>Diese Bestellung enthält keine Naturalrabatte oder Gratisware.</p>
        )}

        <PriceSummary price={grossPrice} withVAT />
        {buttonText && buttonOnClick && (
          <Button
            className="btn btn-secondary digitalized-orders-detail__button"
            onClick={buttonOnClick}
          >
            {buttonText}
          </Button>
        )}
      </div>
    </div>
  );
};

export default DigitalizedOrderDetail;
